<template>
  <div>
    <template>
      <div class="columns">
        <div class="column has-background-white">
            <welcome-page @switchOutlet="switchOutlet" :outletInfo="outletInfo"></welcome-page>
            <column-filter class="is-hidden-touch sticky"></column-filter>
        </div>
        <div class="column is-three-fifths">

          <catalog></catalog>
        </div>
        <div class="column is-hidden-touch has-background-white-ter">
          <div v-if="cartCount === 0" class="is-size-3 sticky">
            <div class="has-text-centered mt-8-em">
              <p class="title has-text-weight-medium has-text-grey-light">Empty Cart</p>
              <span class="icon has-text-grey-light">
                <font-awesome-icon icon="shopping-cart"/>
              </span>
            </div>
          </div>
          <cart v-on:displaybill="displayBill =! displayBill" v-else></cart>
        </div>
      </div>
    </template>
    <template v-if="displayBill">
      <bill v-bind:displayBill="displayBill" v-on:closebill="displayBill =! displayBill"></bill>
    </template>
    <address-select autoLocate="true" noAddressFetch="true" igmoreLastSearchAddress="true" class="is-hidden"></address-select>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import WelcomePage from './WelcomePage'
import Catalog from './catalog/Catalog'
import ColumnFilter from '@/components/filters/ColumnFilter'
import Cart from './cart/Cart'
import Bill from './cart/Bill'
import AddressSelect from "@/components/ux/AddressSelect"

export default {
  title: 'Order online',
  name: 'OutletPage',
  components: {
    Catalog,
    WelcomePage,
    ColumnFilter,
    Cart,
    Bill,
    AddressSelect
  },
  props: ['outletId', 'query', 'outletInfo'],
  data () {
    return {
      displayBill: false
    }
  },
  created () {
    this.startSale()
  },
  computed: {
    ...mapGetters({
      cartCount: 'cart/getCartCount'
    })
  },
  watch: {
    $route(to, from) {
      if (to && to.name === 'Outlet' &&
       ((from && from.name && (from.name.includes('Discovery') || from.name.includes('Business'))) ||
        to.params.id !== from.params.id)) {
        this.doRefreshOutlet()
      }
    }
  },
  methods: {
    startSale () {
      if (this.$store.getters['catalog/isDataLoaded']) {
        return
      }
      this.updateOutletId()
      this.updateQuery()
      this.getOutlet()
      this.getUser()
    },

    updateOutletId () {
      this.$store.dispatch('business/updateOutletId', this.outletId)
    },

    updateQuery () {
      if (!this.query) {
        return
      }
      this.$store.dispatch('business/updateQuery', this.query)
    },

    getOutlet () {
      this.$store.dispatch('business/getOutlet').then(() => {
        this.fetchOtherOutlets()
        this.getSoldOut()
      })
    },

    getCatalog () {
      this.$store.dispatch('catalog/getCatalog')
    },

    getSoldOut () {
      this.$store.dispatch('catalog/getSoldOut').then(() => {
        this.getCatalog()
      })
    },

    getUser () {
      this.$store.dispatch('user/get').then(() => {
        this.fetchCustomerLoyaltyPoints()
      }).catch((error) => {
        if (error.status === 401 || error.code === 'ERR_UNAUTHORIZED') {
          this.$store.dispatch('user/signOut', { enforceSignin: true }).then(() => {
            this.fetchCustomerLoyaltyPoints()
          })
        }
      })
    },

    fetchCustomerLoyaltyPoints () {
      this.$store.dispatch('cart/fetchCustomerLoyaltyPoints')
    },

    fetchOtherOutlets () {
      this.$store.dispatch('business/fetchOtherOutlets')
    },

    switchOutlet (params) {
      this.resetOutlet()
      this.$store.dispatch('catalog/catalogDataLoaded', false)
      this.$router.push({
        name: 'Outlet',
        params: {
          id: params.outletInfo.listingId
        }
      })
    },

    doRefreshOutlet () {
      this.resetOutlet()
      this.$store.dispatch('catalog/catalogDataLoaded', false)
      this.startSale()
    },

    resetOutlet () {
      this.$store.dispatch('cart/resetState')
      this.$store.dispatch('catalog/resetState')
      this.$store.dispatch('business/resetState')
    }
  }
}
</script>
